<template>
	<div class="main-category">
		<section
			:class="[
				'menu-container-hide', 'd-flex',
			]"
			>
			<div
				class="menu-btn-container d-flex align-center justify-center"
				:style="`color:${globalColors.primary};background-color:${globalColors.border}`"
				@click="toogleMenu"
			>
				<p class="menu-btn-text">Categorías</p>
			</div>
				<transition name="lateral" mode="out-in">
					<menu-web
						class="menu-cat-hide"
						v-if="show"
						:categories="eCategories"
						@category-changed="toogleMenu"
					/>
				</transition>
		</section>
		<section>
			<div>
				<h1 class="category-title">{{getCurrentCategoryTitle}}</h1>
				<div class="section-product">
					<div class="d-flex space-between align-center mb-3">
						<el-breadcrumb separator-class="el-icon-arrow-right" ref="ecoBreadcrumb">
							<el-breadcrumb-item
								v-for="(bread, indexBread) in breadCrumbsCaterories"
								:key="indexBread"
								:to="{ name: 'categories', params: { slug: bread.slug || bread.id, categoryId: bread.id } }"
							>{{getBreadCrumbsTitle(bread)}}</el-breadcrumb-item>
						</el-breadcrumb>
						<el-pagination
							class="txt-right"
							layout="prev, pager, next"
							:total="totalPage"
							:page-size="limit"
							:current-page="currentPage"
							@current-change="pageChange"
						/>
					</div>
					<products-categories
						:products="listCategories"
						class="mb-3"
						v-loading="loading"
					/>
				</div>
			</div>
		</section>
		<app-footer />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import appFooter from '@/sections/Footer';
import productsCategories from '@/components/productsCategories';
import menuWeb from '@/components/menuWeb';
import lib from '@/helpers/lib';
import { priceProductConfiguration } from '@/helpers/helper';

function created() {
	({ categoryId: this.categoryId } = this.$route.params);
	this.loadData(this.getCommerceData.id);
	if (this.flagGrouper) {
		this.loadProductsCategories();
	}
}

function lastChildStyle() {
	const childrens = this.$refs.ecoBreadcrumb.$children.map((child) => {
		const newChild = child;
		newChild.$el.children[0].style.color = this.globalColors.titulo;
		return newChild;
	});
	const lastOne = childrens.length - 1;
	const lastItem = this.$refs.ecoBreadcrumb.$children[lastOne].$el;
	lastItem.children[0].style.color = this.globalColors.primary;
	this.$refs.ecoBreadcrumb.$children[lastOne].$el = { ...lastItem };
}

async function loadProductsCategories() {
	this.loading = true;
	const params = {
		eCategories: this.categoryId,
		limit: this.limit,
		page: this.currentPage,
		flagGrouper: this.flagGrouper,
	};
	const response = await this.getProducts(params);
	this.listCategories = response.data;
	this.updateProducts(this.listCategories);
	this.totalPage = Number(response.headers['x-quantity']);
	this.loading = false;
	this.lastChildStyle();
}

function updateProducts(products) {
	const salPriceId = this.getCommerceData.settings.salPriceListId;
	this.listCategories = priceProductConfiguration(salPriceId, products);
}

function getProducts(params) {
	if (this.token) {
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		return this.$httpQtc.get('products/favorites', { headers, params });
	}
	return this.$httpQtc.get('products-public', { params });
}

async function loadData(id) {
	this.breadCrumbsCaterories = [];
	const params = {
		commerceId: id,
	};
	const requests = [
		this.$httpQtc.get('banners-public', { params }),
		this.$httpQtc.get('e-categories-public'),
	];
	([
		{ data: this.banners },
		{ data: this.eCategories },
	] = await Promise.all(requests));
	this.currentCategory = this.getCurrentcategory(this.eCategories, this.categoryId);
	this.breadCrumbsCaterories = this.getBreadCrumbs(this.currentCategory);
	this.$bus.$emit('categories-data', this.eCategories);
	this.updateDescriptionTag(this.currentCategory.description);
	this.setPageTitle(this.currentCategory.title);
}

function getBreadCrumbs(currentCat) {
	if (!currentCat.categoryId) {
		return [].concat(currentCat);
	}
	const parentCategory = this.getCurrentcategory(this.eCategories, currentCat.categoryId);
	const parentBread = this.getBreadCrumbs(parentCategory);
	return [].concat(parentBread, currentCat);
}

function getCurrentcategory(categories, id) {
	let current = categories.find(c => c.id === Number(id));
	if (current) {
		return current;
	}
	const len = categories.length;
	for (let i = 0; i < len; i += 1) {
		const detail = categories[i].detail;
		current = this.getCurrentcategory(detail, id);
		if (current) {
			return current;
		}
	}
	return current;
}

function toogleMenu() {
	this.show = !this.show;
}

function pageChange(newPage) {
	this.currentPage = newPage;
	this.loadProductsCategories();
}

function handlerParamsChange(newParams) {
	({ categoryId: this.categoryId } = newParams);
	this.currentPage = 1;
	this.loadProductsCategories();
	this.currentCategory = this.getCurrentcategory(this.eCategories, this.categoryId);
	this.breadCrumbsCaterories = this.getBreadCrumbs(this.currentCategory);
	this.updateDescriptionTag(this.currentCategory.description);
	this.setPageTitle(this.currentCategory.title);
}

function getCurrentCategoryTitle() {
	return lib.getDeeper('title')(this.currentCategory);
}

function getBreadCrumbsTitle(item) {
	return lib.getDeeper('title')(item);
}

function data() {
	return {
		banners: [],
		breadCrumbsCaterories: [],
		categoryId: null,
		currentCategory: {
			title: '',
		},
		currentPage: 1,
		eCategories: [],
		limit: 10,
		listCategories: [],
		loading: false,
		queryIds: null,
		totalPage: 0,
		show: false,
	};
}

export default {
	name: 'Categories',
	components: {
		appFooter,
		menuWeb,
		productsCategories,
	},
	computed: {
		...mapGetters([
			'bannerTypes',
			'getCommerceData',
			'flagGrouper',
			'token',
		]),
		getCurrentCategoryTitle,
	},
	created,
	data,
	methods: {
		handlerParamsChange,
		getBreadCrumbs,
		getBreadCrumbsTitle,
		getCurrentcategory,
		getProducts,
		lastChildStyle,
		loadData,
		loadProductsCategories,
		pageChange,
		toogleMenu,
		updateProducts,
	},
	watch: {
		'$route.params': handlerParamsChange,
		flagGrouper: loadProductsCategories,
	},
};
</script>
<style lang="scss" scoped>

	.main-container {
		position: relative;
	}

	.menu-container-hide {
		background-color: white;
		cursor: pointer;
		height: 42.7rem;
		position: absolute;
		left: 0%;
		top: 0;
		transition: right 200ms ease-in;
		z-index: 2;

		@media (max-width: 600px) {
			display: none;
		}
	}

	.show-menu {
		right: 88%;
	}

	.menu-btn-container {
		font-family: font(avenirBold);
		font-size: size(msmall);
		width: 3rem;
		z-index: 9;
	}

	.menu-btn-text {
		transform: rotateZ(270deg);
	}

	.section-product {
		margin: 0 auto;
		max-width: 102.4rem;

		@media (max-width: 1100px) {
			margin: 0 3.5rem;
		}

		@media (max-width: 600px) {
			margin: 0 1rem;
		}
	}

	.category-title {
		border-bottom: 0.2rem solid color(textGrey);
		font-family: font(avenirBold);
		font-size: size(maxsmall);
		margin: 1rem 3.5rem 3.5rem;
		padding: 3rem 1rem 1rem;
	}

	.menu-cat-hide {
		box-shadow: 6px 8px 8px -6px rgba(0, 0, 0, 0.11);
		width: 26rem;
	}
</style>


// WEBPACK FOOTER //
// Categories.vue?022fb9da